export default __webpack_public_path__ + "static/media/livBrite_logo.0d77e018.png";